import React from 'react';
import { get } from 'lodash';
import { useFormContext, FieldError as IFieldError } from 'react-hook-form';
import { Select } from '@morressier/alembic';
import { FormFieldSelect as IFormFieldSelect } from '@publishing-engine/domain/types/article';
import { FieldLabel } from 'src/components/Field';
import { Flex } from '@chakra-ui/react';
import FormFieldErrorMessage from './common/FormFieldErrorMessage';

interface IFormFieldSelectProps {
  config: IFormFieldSelect;
  isEditingAllowed?: boolean;
}

const FormFieldSelect: React.FC<IFormFieldSelectProps> = ({
  config,
  isEditingAllowed = true
}) => {
  const {
    register,
    formState: { errors },
    watch
  } = useFormContext();

  const {
    name,
    caseDataFields: { main: field },
    params: { validations, labels }
  } = config;

  const options = validations.options;

  const value = watch(field);
  const error = get(errors, field) as IFieldError;

  return (
    <Flex flexDirection="column" alignItems="flex-start" gap={2} width="100%">
      <FieldLabel
        isRequired={validations.required}
        label={labels.main}
        subText={labels.subtitle}
        helpText={labels.helpText}
      />
      <Select
        id={name}
        {...register(field, { required: validations.required })}
        isInvalid={!!error}
        value={value || ''}
        isReadOnly={!isEditingAllowed}
        aria-label={name}
      >
        <option value={''} disabled={validations.required}>
          {labels.placeholder || 'Select an option'}
        </option>
        {options.map(option => (
          <option key={option} value={option}>
            {labels.options[option]?.main ?? option}
          </option>
        ))}
      </Select>
      <FormFieldErrorMessage config={config} />
    </Flex>
  );
};

export default FormFieldSelect;
